import { render } from "./instructor-grading.vue?vue&type=template&id=ec6e5752&scoped=true"
import script from "./instructor-grading.vue?vue&type=script&lang=js"
export * from "./instructor-grading.vue?vue&type=script&lang=js"

import "./instructor-grading.vue?vue&type=style&index=0&id=ec6e5752&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec6e5752"]])

export default __exports__